import { ActionBrick, registerBrick, GlobalProperties } from 'olympe';
import { getLogger } from '@olympeio/core';
import { MATOMO_SCRIPT_ID, isMatomoTrackingInserted, setMatomoTrackingEnabled } from './helper';

export default class MatomoInsertTrackingCode extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} domain
     * @param {string} siteId
     * @param {function()} forwardEvent
     */
    update($, [domain, siteId], [forwardEvent]) {
        const logger = getLogger('Matomo');

        if ($.get(GlobalProperties.EDITION, true)) {
            logger.debug('Ignoring tracking code in EDITION mode.');
            forwardEvent();
            return;
        }

        if (typeof domain !== 'string' || domain.length === 0) {
            logger.error('Invalid inputs, domain is required and must be string. Ignoring tracking code');
            forwardEvent();
            return;
        }

        if (isMatomoTrackingInserted()) {
            logger.error('Tracking code is already inserted, you probably use the `[Matomo] InsertTrackingCode` brick several times in your application');
            forwardEvent();
            return;
        }

        const enabled = typeof siteId === 'string' && siteId.length > 0;
        setMatomoTrackingEnabled($, enabled);

        if (!enabled) {
            forwardEvent();
            return;
        }

        const _paq = window._paq || [];
        window._paq = _paq;
        (function() {
            const u=`//${domain}/`;
            // Unshift to ensure we insert these instructions as the first ones to be evaluated by Matomo engine.
            _paq.unshift(['setTrackerUrl', u+'matomo.php'], ['setSiteId', siteId]);
            const g = document.createElement('script');
            const s = document.getElementsByTagName('script')[0];
            g.id = MATOMO_SCRIPT_ID;
            g.async=true;
            g.src=u+'matomo.js';
            s.parentNode.insertBefore(g,s);
        })();
        forwardEvent();
    }
}

registerBrick('018800d34109214275d2', MatomoInsertTrackingCode);
